import { render, staticRenderFns } from "./TagsAndSubtags.vue?vue&type=template&id=925d18d4"
import script from "./TagsAndSubtags.vue?vue&type=script&lang=js"
export * from "./TagsAndSubtags.vue?vue&type=script&lang=js"
import style0 from "./TagsAndSubtags.vue?vue&type=style&index=0&id=925d18d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports